import React from 'react';
import { useParams } from 'react-router-dom';
import { FallbackProps } from 'react-error-boundary';
import { Col, Container, Row } from 'react-bootstrap';

export const ErrorBoundaryFallback: React.FC<
  FallbackProps & { isFacilitator?: boolean }
> = ({ error, isFacilitator }) => {
  const { gameCode } = useParams();

  // Fallback error for AR Pyramid game not found
  if (error.isArPyramid) {
    return (
      <div className={'mask'}>
        <Container>
          <Row className={'mt-4'}>
            <Col className={'text-center'}>
              <span>
                <strong>AR Pyramid game not found.</strong>
                <br />
                <br />
                The game code "{gameCode}" is not valid or has expired.
                <br />
                Please check the game code and try again.
              </span>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  //fallback error if the game is expired
  if (
    error.status === 404 ||
    error.message === `GameEntity ${gameCode} not found`
  ) {
    return (
      <div className={'mask'}>
        <Container>
          <Row className={'mt-4'}>
            <Col className={'text-center'}>
              <span>
                This activity is no longer available.
                <br />
                {!isFacilitator && (
                  <>
                    The session linked to this URL has expired or been removed.
                    <br />
                    If you believe this is a mistake, please get in touch with
                    the activity organiser for a new link.
                  </>
                )}
                {isFacilitator && (
                  <>
                    The session linked to this URL has expired (48 hours after
                    the Activity End Date) or has been removed manually by
                    request.
                    <br />
                    If you believe this is a mistake, please email{' '}
                    <a href="mailto:support@catalystglobal.games">
                      support@catalystglobal.games
                    </a>
                  </>
                )}
              </span>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return <>{error.error?.toString() || error.toString()}</>;
};
